import mainApi from "./mainApi";

export function tipsApi() {
    return {
        getTips: async function() {
            return mainApi.get('/tips');
        }
    }
}